import React, { useEffect, useState, useContext, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Toolbar,
  Typography,
  Grid,
  Paper,
  IconButton,
  Tooltip,
  TextField,
  Snackbar,
  Select,
  MenuItem,
  Button,
  Modal,
  Box,
} from "@material-ui/core";
import { Alert, Skeleton } from "@material-ui/lab";
import TablePaginationActions from "../utils/TablePaginationActions";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import ServicesContext from "../../contexts/servicesContext";
import { green, grey, red, yellow } from "@material-ui/core/colors";
import Constants from "../../common/constants";

const rowsPerPage = 20;

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflowX: "auto",
    flexDirection: "column",
    width: "100%",
  },
  input: {
    display: "none",
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

function DormApplications({
  isFirstStage,
  isSecondStage,
  isAcceptedApplicationsStage,
  isDeclinedApplicationsStage,
}) {
  const classes = useStyles();
  const services = useContext(ServicesContext);

  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState(2);
  // const [hasVaccinationPassport, setHasVaccinationPassport] = useState(false);
  const [privilege, setPrivilege] = useState(0);
  const [listOfPrivileges, setListOfPrivileges] = useState([]);

  const [applicationsCount, setApplicationsCount] = useState(0);
  const [applications, setApplications] = useState([]);
  const [regions, setRegions] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  const [fio, setFio] = useState("");

  // Alert сообщения
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  // const handleHasVaccinationPassportChange = () => {
  //   setHasVaccinationPassport(!hasVaccinationPassport);
  //   setCurrentPage(0);
  // };

  const handleSearchQueryChange = (event) => {
    setFio(event.target.value.split(/\s+/).join(""));
    setCurrentPage(0);
  };

  const handleFileDownload = (id, name) => {
    services.fileUpload.getDocument(id, name);
  };

  const handleFileChange = (event, application) => {
    const fileType = Constants.FILE_TYPES.benefitConfirmationDocDorm;
    const files = event.target.files;
    services.fileUpload
      .secretaryUploadDocuments(application, files, fileType)
      .then((response) => {
        setSuccessMessage("Файл успешно загружен на сервер");
        console.log(response);
      })
      .catch((err) => {
        setErrorMessage(err.response.data.message);
        console.log(err);
      })
      .finally(() => (event.target.value = null));
  };

  const handleDownloadBtn = () => {
    let stage;
    let fileName;
    if (isFirstStage) {
      stage = 1;
      fileName = "Заявки(1-этап).xlsx";
    } else if (isSecondStage) {
      stage = 2;
      fileName = "Заявки(2-этап).xlsx";
    } else if (isAcceptedApplicationsStage) {
      stage = 3;
      fileName = "Подтвержденные заявки.xlsx";
    } else if (isDeclinedApplicationsStage) {
      stage = 6;
      fileName = "Отклоненные заявки.xlsx";
    } else {
      setErrorMessage("Ошибка при загрузке!");
    }

    if (stage) {
      services.studentAffairs
        .getApplicationsAsExcel(stage, gender)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => setErrorMessage(error.response.data.message));
    } else {
      setErrorMessage("Ошибка при загрузке!");
    }
  };

  const handleApprovement = (applicationId, userId, isApproved) => {
    const index = applications.findIndex(
      (element) => element.id === applicationId
    );
    const oldApplication = applications[index];
    setApplications([
      ...applications.slice(0, index),
      { ...oldApplication, hasStatusChanged: true },
      ...applications.slice(index + 1),
    ]);

    if (isFirstStage) {
      isApproved
        ? services.studentAffairs
            .moveToSecondStep(userId)
            .then(() =>
              setSuccessMessage(
                "Successfully moved application to the next step"
              )
            )
            .catch((error) => setErrorMessage(error.response.data.message))
        : services.studentAffairs
            .revokeApproval(userId)
            .then(() => setSuccessMessage("Successfully revoked application"))
            .catch((error) => setErrorMessage(error.response.data.message));
    }

    if (isSecondStage) {
      isApproved
        ? services.studentAffairs
            .acceptApplication(userId)
            .then(() =>
              setSuccessMessage(
                "Successfully moved application to the next step"
              )
            )
            .catch((error) => setErrorMessage(error.response.data.message))
        : services.studentAffairs
            .returnToFirstStage(userId)
            .then(() =>
              setSuccessMessage("Successfully returned to the first stage")
            )
            .catch((error) => setErrorMessage(error.response.data.message));
    }

    if (isAcceptedApplicationsStage) {
      isApproved
        ? services.studentAffairs
            .moveToSecondStep(userId)
            .then(() =>
              setSuccessMessage(
                "Successfully moved application to the next step"
              )
            )
            .catch((error) => setErrorMessage(error.response.data.message))
        : services.studentAffairs
            .revokeApproval(userId)
            .then(() => setSuccessMessage("Successfully revoked application"))
            .catch((error) => setErrorMessage(error.response.data.message));
    }

    if (isDeclinedApplicationsStage) {
      services.studentAffairs
        .returnToFirstStage(userId)
        .then(() =>
          setSuccessMessage("Successfully moved application to the first step")
        )
        .catch((error) => setErrorMessage(error.response.data.message));
    }
  };

  const findNeededMethod = useCallback(() => {
    const {
      getApplicationsFromFirstStep,
      getApplicationsFromSecondStep,
      getAcceptedApplications,
      getRefusedApplications,
    } = services.studentAffairs;

    switch (true) {
      case isFirstStage:
        return getApplicationsFromFirstStep;
      case isSecondStage:
        return getApplicationsFromSecondStep;
      case isAcceptedApplicationsStage:
        return getAcceptedApplications;
      case isDeclinedApplicationsStage:
        return getRefusedApplications;
      default:
        return getApplicationsFromFirstStep;
    }
  }, [
    services,
    isFirstStage,
    isSecondStage,
    isAcceptedApplicationsStage,
    isDeclinedApplicationsStage,
    localStorage.getItem("AdmissionOfYear"),
  ]);

  useEffect(() => {
    setLoading(true);

    const debouncedSearch = setTimeout(() => {
      // 'searchQuery' is an optional argument (it will only appear in the third stage)
      findNeededMethod()(currentPage, gender, false, privilege, fio)
        .then((response) => {
          setApplications(() => {
            if (isAcceptedApplicationsStage) {
              const { list, total_number } = response.data;
              setApplicationsCount(total_number);
              setLoading(false);
              return list.map((application) => ({
                ...application,
                hasStatusChanged: false, // initially
              }));
            }

            const { list, total_number } = response.data;

            setApplicationsCount(total_number);

            setLoading(false);

            return list.map((application) => ({
              ...application,
              hasStatusChanged: false, // initially
            }));
          });

          services.personalPage
            .getPersonalInformationByIds(
              response.data.list.map(
                (application) => application.userDtoResponse.id
              )
            )
            .then((response) => setRegions(response.data))
            .catch((error) => console.error(error.response));
        })
        .catch((error) => {
          console.error(error.response);
        });
    }, 1500);

    services.dormAccomodation
      .getBenefits()
      .then((response) => setListOfPrivileges(response.data))
      .catch((error) => console.error(error.response));

    return () => clearInterval(debouncedSearch);
  }, [
    isAcceptedApplicationsStage,
    services,
    currentPage,
    false,
    gender,
    fio,
    privilege,
    findNeededMethod,
  ]);

  useEffect(() => {
    if (successMessage) {
      setOpenSuccess(true);
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      setOpenError(true);
    }
  }, [errorMessage]);


  const [openModal, setOpenModal] = useState(false);
  const [currentApplication, setCurrentApplication] = useState(null);
  const [comment, setComment] = useState("");

  const handleOpen = (application) => {
    setCurrentApplication(application);
    setComment(application.comment || "");
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setCurrentApplication(null);
    setComment("");
  };

  const handleSaveComment = async () => {
    try {
      await services.studentAffairs.addCommentToApplication(currentApplication.id, comment);
      setSuccessMessage("Комментарий успешно сохранен");
      setOpenSuccess(true);
      setApplications((prevApplications) =>
      prevApplications.map((app) =>
        app.id === currentApplication.id
          ? { ...app, comment }
          : app
      )
    );
    } catch (error) {
      setErrorMessage("Ошибка при сохранении комментария");
      setOpenError(true);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <Snackbar
        open={openSuccess}
        autoHideDuration={1500}
        onClose={() => setOpenSuccess(false)}
      >
        <Alert severity="success" onClose={() => setOpenSuccess(false)}>
          {successMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openError}
        autoHideDuration={1500}
        onClose={() => setOpenError(false)}
      >
        <Alert severity="error" onClose={() => setOpenError(false)}>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Paper className={classes.paper}>
        <Toolbar>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                className={classes.title}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                {isFirstStage &&
                  "Заявки на получение места в общежитии (1 этап)"}
                {isSecondStage &&
                  "Заявки на получение места в общежитии (2 этап)"}
                {isAcceptedApplicationsStage && "Подтвержденные заявки"}
                {isDeclinedApplicationsStage && "Отклоненные заявки"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" spacing={3}>
                {
                  <Grid item>
                    <TextField
                      placeholder="Введите ваш запрос (ФИО)"
                      style={{ width: "300px" }}
                      onChange={handleSearchQueryChange}
                    />
                  </Grid>
                }
                <Tooltip placement="left" title="Пол">
                  <Grid item>
                    <Select
                      labelId="gender-select-label"
                      defaultValue={gender}
                      value={gender}
                      label="Пол"
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <MenuItem value={2}>Все</MenuItem>
                      <MenuItem value={1}>Мужской</MenuItem>
                      <MenuItem value={0}>Женский</MenuItem>
                    </Select>
                  </Grid>
                </Tooltip>
                {/* <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hasVaccinationPassport}
                        onChange={handleHasVaccinationPassportChange}
                        color="primary"
                      />
                    }
                    label={
                      hasVaccinationPassport
                        ? "Имеется паспорт вакцинации (✓)"
                        : "Не имеется паспорт вакцинации (-)"
                    }
                  />
                </Grid> */}
                <Tooltip placement="right" title="Категория льготы">
                  <Grid item>
                    <Select
                      labelId="gender-select-label"
                      defaultValue={privilege}
                      value={privilege}
                      label="Привелегий"
                      onChange={(e) => setPrivilege(e.target.value)}
                      style={{
                        width: "200px",
                      }}
                    >
                      <MenuItem value={0}>Любая</MenuItem>
                      {listOfPrivileges.map(({ id, privilegeDescription }) => (
                        <MenuItem value={id} style={{ whiteSpace: "normal" }}>
                          {id + " - " + privilegeDescription}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Tooltip>
                <Tooltip placement="right" title="Скачать в Excel">
                  <Grid item>
                    <Button
                      onClick={() => handleDownloadBtn()}
                      startIcon={<GetAppIcon />}
                      variant="contained"
                      disableElevation
                      color="success"
                    >
                      Скачать в Excel
                    </Button>
                  </Grid>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>№</TableCell>
              <TableCell>ФИО</TableCell>
              {/* <TableCell>Имя</TableCell>
              <TableCell>Отчество</TableCell> */}
              <TableCell>Электронная почта</TableCell>
              <TableCell>Номер телефона</TableCell>
              <TableCell>
                Иногородный
                {/* <Select>
                  <MenuItem>Да</MenuItem>
                  <MenuItem>Нет</MenuItem>
                  <MenuItem>Не заполнен</MenuItem>
                </Select> */}
              </TableCell>
              <TableCell align="right">Дата подачи заявления</TableCell>
              <TableCell align="right">Категория льготы</TableCell>
              <TableCell align="right">Подтверждающий документ</TableCell>
              <TableCell align="right">Комментарий</TableCell>
              {/* <TableCell align="right">Паспорт вакцинации</TableCell> */}
              <TableCell align="right"></TableCell>
              {(isFirstStage || isSecondStage) && (
                <TableCell align="right"></TableCell>
              )}
            </TableRow>
          </TableHead>

          {loading ? (
            <TableBody>
              {[...Array(10)].map((x, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    {/* <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell> */}
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    {/* <TableCell align="right">
                            <Skeleton variant="text" />
                          </TableCell> */}
                    {(isFirstStage || isSecondStage) && (
                      <TableCell align="right">
                        <Skeleton variant="text" />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            <TableBody>
              {applications.map((application, index) => (
                <TableRow key={application.id}>
                  <TableCell component="th" scope="row">
                    {currentPage * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {application.userDtoResponse.surname +
                      " " +
                      application.userDtoResponse.name +
                      " "}
                    {application.userDtoResponse.patronymic
                      ? application.userDtoResponse.patronymic
                      : ""}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {application.userDtoResponse.email}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {application.userDtoResponse.phoneNumber}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {regions.find(
                      (region) =>
                        region.user.id === application.userDtoResponse.id
                    )?.residenceAddressId
                      ? regions.find(
                          (region) =>
                            region.user.id === application.userDtoResponse.id
                        )?.residenceAddressId?.centerKatoRegion.codePrefix ===
                        71
                        ? "Нет"
                        : "Да"
                      : "Не заполнен"}
                  </TableCell>
                  <TableCell align="right">
                    {new Date(application.createdDate).toString()}
                  </TableCell>
                  <TableCell align="right">
                    {application.privilege.id}
                  </TableCell>
                  <TableCell align="right">
                    {application.privilegeProof &&
                      `Количество загруженных документов - ${application.privilegeProof.length}`}
                    <TableCell>
                      {application.privilegeProof && (
                        <IconButton>
                          <GetAppIcon
                            onClick={() =>
                              application.privilegeProof.map((applFile) =>
                                handleFileDownload(
                                  applFile.id,
                                  `${applFile.fileType.name} (${applFile.userDtoResponse.surname} ${applFile.userDtoResponse.name})`
                                )
                              )
                            }
                          />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell>
                      <input
                        className={classes.input}
                        id={`icon-button-file-${index}`}
                        type="file"
                        multiple="true"
                        onChange={(event) =>
                          handleFileChange(event, application)
                        }
                      />
                      <label htmlFor={`icon-button-file-${index}`}>
                        <Tooltip
                          title="Удаляет все ранее загруженные документы!"
                          sx={{ fontSize: "18px" }}
                        >
                          <IconButton aria-label="upload file" component="span">
                            <PublishIcon></PublishIcon>
                          </IconButton>
                        </Tooltip>
                      </label>
                    </TableCell>
                  </TableCell>

          <TableCell component="th" scope="row">
            {application.comment || " "}
            
            <Button color="primary" variant="contained" onClick={() => handleOpen(application)}>
              {application.comment ? "Изменить" : "Добавить"}
            </Button>
          </TableCell>

                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      target="_blank"
                      href={`/enrollees/${application.userDtoResponse.id}`}
                    >
                      Подробнее
                    </Button>
                  </TableCell>
                  {isFirstStage && (
                    <>
                      <TableCell align="right">
                        <Tooltip title="На 2-этап">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                true
                              )
                            }
                          >
                            <CheckOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: green[600] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Отклонить заявку">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                false
                              )
                            }
                          >
                            <CancelOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: red[500] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </>
                  )}
                  {isSecondStage && (
                    <>
                      <TableCell align="right">
                        <Tooltip title="Принять">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                true
                              )
                            }
                          >
                            <CheckOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: green[600] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Вернуть на 1 этап">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                false
                              )
                            }
                          >
                            <CancelOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: yellow[500] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </>
                  )}
                  {isAcceptedApplicationsStage && (
                    <>
                      <TableCell align="right">
                        <Tooltip title="Вернуть на 2 этап">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                true
                              )
                            }
                          >
                            <CancelOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: yellow[500] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Отклонить заявку">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                undefined
                              )
                            }
                          >
                            <CancelOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: red[500] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </>
                  )}
                  {isDeclinedApplicationsStage && (
                    <>
                      <TableCell align="right">
                        <Tooltip title="Вернуть на 1 этап">
                          <IconButton
                            disabled={application.hasStatusChanged}
                            onClick={() =>
                              handleApprovement(
                                application.id,
                                application.userDtoResponse.id,
                                false
                              )
                            }
                          >
                            <CancelOutlinedIcon
                              style={
                                application.hasStatusChanged
                                  ? { color: grey[500] }
                                  : { color: yellow[500] }
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        <TablePagination
          count={applicationsCount}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          component="div"
          rowsPerPageOptions={[]}
          onChangePage={handleChangePage}
          ActionsComponent={TablePaginationActions}
        />
      </Paper>
      <Modal open={openModal} onClose={handleClose}>
        <Box className={classes.modal}>
          <Typography variant="h6" gutterBottom>
            {currentApplication?.comment ? "Изменить комментарий" : "Добавить комментарий"}
            <br />
          </Typography>
          <TextField
            fullWidth
            label="Комментарий"
            multiline
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Button onClick={handleSaveComment} color="primary" className={classes.button} sx={{ mt: 2 }} variant="contained">
          {currentApplication?.comment ? "Изменить" : "Добавить"}
          </Button>
          <Button onClick={handleClose} className={classes.button}>Отмена</Button>
        </Box>
      </Modal>
    </>
  );
}

DormApplications.defaultProps = {
  isFirstStage: false,
  isSecondStage: false,
  isAcceptedApplicationsStage: false,
  isDeclinedApplicationsStage: false,
};

export default DormApplications;
